module.exports = __webpack_public_path__ + "static/media/bg.e905b7ae.png";